import React, { Component } from 'react';
import { get, has } from "lodash"

import { withStepsState } from "../../../shared/containers/containerStepsState"

import FirstTitle from '../../../shared/items/static/firstTitle';
import InputWrapper from '../../../shared/items/controls/inputWrapper';
import NameNextStepButton from "./nameNextStepButton"
import ValidateMessage from "./../../../shared/items/static/validateMessage"
import StepContentWrapper from "./../stepContentWrapper"
import StepControl from "./../stepControl"
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "../../../shared/services/service.step"
import { steps } from "../../../shared/static.steps"

import "./../../../shared/services/service.step.scss"
import styles from "./name.module.scss"

class Name extends Component {
  constructor() {
    super();

    this.state = {
      isOpenName: false,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.name) && !this.state.isOpenName)
      this.setState({ isOpenName: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, data, onSetStepData } = this.props
    const { isOpenName } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.name,
      isOpen: isOpenName,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenName && !has(data, ["name"]))
      onSetStepData("name")

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      isOpenName: state,
    })
  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenName } = this.state
    const params = {
      className: "wrapperName",
      currentIndex: currentIndex,
      stepIndex: steps.name,
    }

    return isOpenName ?
      <div className={buildStepClassName({ params })}>

        <StepContentWrapper>
          <FirstTitle>What's your name?</FirstTitle>

          <InputWrapper
            name="name"
            keyName="value"
            placeholder="What's your name?"
            onChange={onUpdateStepData.bind(this)}
            valueStore={get(data, ["name", "value"], null)}
          />

          <div className={styles.container_validateMessage}>
            <ValidateMessage message={get(data, ["name", "validString"], null)} />
          </div>
        </StepContentWrapper>

        <StepControl>
          <NameNextStepButton>Continue</NameNextStepButton>
        </StepControl>
      </div>
      : null
  }
}

export default withStepsState(Name);